var render = function render(){var _vm=this,_c=_vm._self._c;return _c('lg-finder',{ref:"finder",attrs:{"id":this.id,"fields":_vm.fields,"title":"Busca Status","url":"/api/status"},on:{"onSelect":_vm.onSelect}})
}
var staticRenderFns = []

export { render, staticRenderFns }